import { useSyncedHealth } from '../sync/HealthConnection';
import { DataSourceLabel } from '../../components/ui/DataSourceLabel';
import { EmptyState } from '../../components/ui/EmptyState';
import { MetricCard } from '../../components/ui/MetricCard';
import { MetricGrid } from '../../components/ui/MetricGrid';
import { PageHeader } from '../../components/ui/PageHeader';
import { SectionHeader } from '../../components/ui/SectionHeader';
import { StatusBadge } from '../../components/ui/StatusBadge';
import { cycleRecords, latestMetrics, mockUser, todayRecord } from '../../mock/bodyData';
import { createTodaySummary } from './todaySummary';
import './TodayPage.css';

export function TodayPage() {
  const synced = useSyncedHealth();
  const summary = createTodaySummary({
    metrics: synced.metrics.length ? synced.metrics : latestMetrics, cycles: synced.cycles.length ? synced.cycles : cycleRecords, record: todayRecord, timeZone: mockUser.timezone,
  });

  return (
    <div className="page-stack">
      <PageHeader eyebrow="TODAY" title={summary.title} subtitle="A compact view of recovery and body signals." />
      <section className="readiness-panel" aria-label="Apple Health connection">
        <div>
          <SectionHeader title="Apple Health" />
          <p>{synced.count ? 'Showing records received from your iPhone. Web browsers do not read Apple Health directly.' : 'No iPhone Health records have been imported. Sync needs the iOS bridge and private Body API.'}</p>
        </div>
        <div><StatusBadge tone="neutral">{synced.count ? 'RECORDS RECEIVED' : 'NOT CONNECTED'}</StatusBadge></div>
      </section>
      <section className="readiness-panel" aria-label="Readiness">
        <div>
          <SectionHeader title="Readiness" />
          <p>{summary.readinessNote}</p>
        </div>
        <div className="readiness-score">
          <span className="numeric">{summary.readinessScore}</span>
          <StatusBadge tone="neutral">{summary.readinessStatus}</StatusBadge>
        </div>
      </section>
      <section>
        <SectionHeader title="Key Metrics" />
        <MetricGrid>
          {summary.metrics.map((metric) => (
            <MetricCard key={metric.label} label={metric.label} value={metric.value} metadata={metric.metadata}>
              {metric.source ? <DataSourceLabel source={metric.source} estimated={metric.estimated} /> : null}
            </MetricCard>
          ))}
        </MetricGrid>
      </section>
      <section>
        <SectionHeader title="Check-in" />
        <div className="checkin-grid">
          <MetricCard label="Energy" value={summary.energy} />
          <MetricCard label="Soreness" value={summary.soreness} />
          <MetricCard label="Pain" value="—" metadata="No recorded check-in yet" />
        </div>
      </section>
      <section>
        <SectionHeader title="Today’s Training" />
        <EmptyState title="No recorded training today" description="The Training view currently contains example records; they are not your synced training history." />
      </section>
      <section>
        <SectionHeader title="Insight" />
        <EmptyState title="No personal insights yet" description="Personal insights require real health history. Example insights in the Insights view are not based on your Apple Health data." />
      </section>
    </div>
  );
}
